import { render, staticRenderFns } from "./VpayAccountOrder.vue?vue&type=template&id=64a7837d&scoped=true"
import script from "./VpayAccountOrder.vue?vue&type=script&lang=js"
export * from "./VpayAccountOrder.vue?vue&type=script&lang=js"
import style0 from "./VpayAccountOrder.vue?vue&type=style&index=0&id=64a7837d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7837d",
  null
  
)

export default component.exports